var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmptyState = function SvgEmptyState(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 3233"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "customer (1)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 3212"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 3211"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 3208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 3207"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 100,
    fill: "#e2f1fe",
    "data-name": "Ellipse 17"
  })))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-413.063 1010.604)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M532.325-973.605h-68.968a6.293 6.293 0 0 0-6.293 6.293v112.624a6.293 6.293 0 0 0 6.293 6.293h90.712a6.29 6.29 0 0 0 6.288-6.293v-90.874Z",
    "data-name": "Pfad 593"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#dbe4f1",
    "data-name": "Gruppe 3231"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M471.209-955.034h75.007v4.552h-75.007Z",
    "data-name": "Pfad 594"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.209-938.33h75.007v4.549h-75.007Z",
    "data-name": "Pfad 595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.209-921.627h75.007v4.546h-75.007Z",
    "data-name": "Pfad 596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.209-904.923h75.007v4.551h-75.007Z",
    "data-name": "Pfad 597"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.209-888.22h75.007v4.551h-75.007Z",
    "data-name": "Pfad 598"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.209-871.516h75.007v4.551h-75.007Z",
    "data-name": "Pfad 599"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#dbe4f1",
    d: "M532.324-951.862a6.293 6.293 0 0 0 6.293 6.293h21.741l-28.034-28.036Z",
    "data-name": "Pfad 600"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#19437b",
    d: "m534.638-879.662 3.471-3.471 6.125 6.125-3.471 3.471Z",
    "data-name": "Pfad 601"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#215999",
    d: "M498.534-919.261a27.992 27.992 0 1 0 19.8-8.209 28 28 0 0 0-19.8 8.209m35.286 35.288a21.892 21.892 0 1 1 6.42-15.488 21.9 21.9 0 0 1-6.42 15.488",
    "data-name": "Pfad 602"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.694,
    height: 33.915,
    fill: "#215999",
    "data-name": "Rechteck 447",
    rx: 0.39,
    transform: "rotate(-45 -784.99 -1084.346)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e2f1fe",
    "data-name": "Gruppe 3232",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "m540.274-872.291 1.247-1.247 8.944 8.945-1.247 1.246Z",
    "data-name": "Pfad 603"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m551.252-861.31 1.247-1.247 2.559 2.56-1.247 1.246Z",
    "data-name": "Pfad 604"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyState);
export default ForwardRef;